/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import {
  showLoader,
  userID,
  hideLoader,
  showAlert,
  isEmpty,
  isEmail,
  isSingleSelect,
  showContaimerLoader,
} from "../Settings/Settings";
import { apiUrl, headerconfig } from "../Settings/Config";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { values } from "underscore";
var module = "employee/";
var moduleName = "User";
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = this.props.location.state?.editID;
    this.state = {
      editID:
        editID !== "" &&
        typeof editID !== undefined &&
        typeof editID !== "undefined"
          ? editID
          : "",
      userID: userID(),
      postdata: {
        empName: "",
        employeeID: "",
        empEmail: "",
        empPhone: "",
        empDepartmentID: "",
        empDOB: "",
        empMaritalStatus: "",
        empGender: "",
        status: "",
      },
      detaildata: [],
      departmentList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    this.loadDepartment();
    if (this.state.editID !== "") {
      var params = {
        params:
          "&userID=" + this.state.userID + "&detail_id=" + this.state.editID,
        url: module + "details",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/" + module);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      this.state.editID !== ""
    ) {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var empStatus = result.empStatus === "A" ? "Active" : "In Active";
          var status =
            result.empStatus !== "" && result.empStatus !== null
              ? {
                  label: empStatus,
                  value: result.empStatus,
                }
              : "";
          var gender = "";
          if (result.empGender === "M") {
            gender = { value: "M", label: "Male" };
          } else if (result.empGender === "F") {
            gender = { value: "F", label: "Female" };
          } else if (result.empGender === "O") {
            gender = { value: "O", label: "Others" };
          }

          var clientupdatedata = {
            empName: result.empName,
            employeeID: result.employeeID,
            empEmail: result.empEmail,
            empPhone: result.empPhone,
            empDepartmentID: result.department,
            empDOB: result.empDOB !== "" && result.empDOB !== "0000-00-00" ? new Date(result.empDOB) : "",
            empMaritalStatus:
              result.empMaritalStatus !== ""
                ? {
                    label: result.empMaritalStatus,
                    value: result.empMaritalStatus,
                  }
                : "",
            empGender: gender,
            status: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadDepartment() {
    var urlShringTxt =
      apiUrl + "department/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ departmentList: res.data.result });
      }
    });
  }

  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      empName: postData.empName,
      employeeID: postData.employeeID,
      empEmail: postData.empEmail,
      empPhone: postData.empPhone,
      empDepartmentID: postData.empDepartmentID?.value || "",
      empDOB:
        postData.empDOB !== "" ? format(postData.empDOB, "yyyy-MM-dd") : "",
      empMaritalStatus: postData.empMaritalStatus?.value || "",
      empGender: postData.empGender?.value || "",
      status: postData.status?.value || "A",
      userID: this.state.userID,
    };

    var post_url = module + "add";
    if (this.state.editID !== "") {
      postObject["edit_id"] = this.state.editID;
      post_url = module + "update";
    }
    this.props.getFormPost(postObject, post_url, "add");
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="employee" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={"/" + module}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            departmentList={this.state.departmentList}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const {
    empName,
    employeeID,
    empEmail,
    empDepartmentID,
    empPhone,
    empMaritalStatus,
    empGender,
    status,
  } = props.fields;

  return {
    fields: [
      "empName",
      "employeeID",
      "empEmail",
      "empPhone",
      "empDepartmentID",
      "empMaritalStatus",
      "empGender",
      "status",
    ],
    validations: {
      empName: [[isEmpty, empName]],
      employeeID: [[isEmpty, employeeID]],
      empPhone: [[isEmpty, empPhone]],
      empEmail: [[isEmail, empEmail]],
      empDepartmentID: [[isSingleSelect, empDepartmentID]],
      empMaritalStatus: [[isSingleSelect, empMaritalStatus]],
      empGender: [[isSingleSelect, empGender]],
      status: [[isSingleSelect, status]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
  }

  goBack() {
    this.props.history.push("/users");
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChange(name, value) {
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgempName,
      errMsgemployeeID,
      errMsgempPhone,
      errMsgempEmail,
      errMsgempDepartmentID,
      errMsgempMaritalStatus,
      errMsgempGender,
      errMsgStatus = "";

    if ($validation.empName.error.reason !== undefined) {
      errMsgempName = $validation.empName.show && (
        <span className="error">{$validation.empName.error.reason}</span>
      );
    }
    if ($validation.employeeID.error.reason !== undefined) {
      errMsgemployeeID = $validation.employeeID.show && (
        <span className="error">{$validation.employeeID.error.reason}</span>
      );
    }
    if ($validation.empPhone.error.reason !== undefined) {
      errMsgempPhone = $validation.empPhone.show && (
        <span className="error">{$validation.empPhone.error.reason}</span>
      );
    }
    if ($validation.empEmail.error.reason !== undefined) {
      errMsgempEmail = $validation.empEmail.show && (
        <span className="error">{$validation.empEmail.error.reason}</span>
      );
    }
    if ($validation.empDepartmentID.error.reason !== undefined) {
      errMsgempDepartmentID = $validation.empDepartmentID.show && (
        <span className="error">
          {$validation.empDepartmentID.error.reason}
        </span>
      );
    }
    if ($validation.empMaritalStatus.error.reason !== undefined) {
      errMsgempMaritalStatus = $validation.empMaritalStatus.show && (
        <span className="error">
          {$validation.empMaritalStatus.error.reason}
        </span>
      );
    }
    if ($validation.empGender.error.reason !== undefined) {
      errMsgempGender = $validation.empGender.show && (
        <span className="error">{$validation.empGender.error.reason}</span>
      );
    }
    if ($validation.status.error.reason !== undefined) {
      errMsgStatus = $validation.status.show && (
        <span className="error">{$validation.status.error.reason}</span>
      );
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Name"
                name="empName"
                value={fields.empName}
                {...$field("empName", (e) =>
                  onChange("empName", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgempName}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Employee ID<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Employee ID"
                name="employeeID"
                value={fields.employeeID}
                {...$field("employeeID", (e) =>
                  onChange("employeeID", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgemployeeID}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">Email</label>
              <input
                type="text"
                className="form-control"
                placeholder="Email"
                name="empEmail"
                value={fields.empEmail}
                {...$field("empEmail", (e) =>
                  onChange("empEmail", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgempEmail}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Phone<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Phone"
                name="empPhone"
                value={fields.empPhone}
                {...$field("empPhone", (e) =>
                  onChange("empPhone", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgempPhone}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Department<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.empDepartmentID}
                onChange={this.handleSelectChange.bind(this, "empDepartmentID")}
                placeholder="Select Department"
                isClearable={true}
                options={this.props.departmentList}
              />
              {errMsgempDepartmentID}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">DOB</label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                className="form-control"
                selected={fields.empDOB}
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
                onChange={this.handleChange.bind(this, "empDOB")}
                placeholderText="Select DOB"
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Marital Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.empMaritalStatus}
                onChange={this.handleSelectChange.bind(
                  this,
                  "empMaritalStatus"
                )}
                placeholder="Select Marital Status"
                isClearable={true}
                options={[
                  { value: "Single", label: "Single" },
                  { value: "Married", label: "Married" },
                  { value: "Widowed", label: "Widowed" },
                  { value: "Separated", label: "Separated" },
                  { value: "Divorced", label: "Divorced" },
                ]}
              />
              {errMsgempMaritalStatus}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Gender<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.empGender}
                onChange={this.handleSelectChange.bind(this, "empGender")}
                placeholder="Select Gender"
                isClearable={true}
                options={[
                  { value: "M", label: "Male" },
                  { value: "F", label: "Female" },
                  { value: "O", label: "Others" },
                ]}
              />
              {errMsgempGender}
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.status}
                onChange={this.handleSelectChange.bind(this, "status")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Submit
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
